import React from 'react';
import {
  Button,
} from 'react-bootstrap';
import {
  AiOutlineMenu,
} from 'react-icons/ai';
import { FiDownload } from 'react-icons/fi';
import { ImAttachment } from 'react-icons/im';
import { IoEyeOutline } from 'react-icons/io5';
import TableEdit from 'components/EditableTable/Table';
import DocDetailOffcanvas from 'components/DocsManagment/DetailOffcanvas';
import useModal from 'hooks/useModal';
import { DocRequestEntity, DocRequestStatus } from 'types/DocRequest';
import moment from 'moment';
import DocStatusBadge from 'components/DocsManagment/StatusBadge';
import UploadDocModal from 'components/DocsManagment/UploadDocModal';

type DocsTableEditProps = {
  data?: DocRequestEntity[],
  reloadData: ( newData: DocRequestEntity ) => void
  handleViewDocument: (
    documentoId: number,
    cuentaDeInversionID: number,
    url: string,
    nombreArchivo: string,
    tipoArchivo: string,
    descargar: boolean,
  ) => void;
};

function DocsTableEdit( {
  data,
  reloadData,
  handleViewDocument,
}: DocsTableEditProps ) {
  const {
    showModal: showCanvas,
    closeModal: closeCanvas,
    openModal: openCanvas,
    selectedItem,
  } = useModal<DocRequestEntity>();

  const {
    showModal: showUploadFileModal,
    closeModal: closeUploadFileModal,
    openModal: openUploadFileModal,
    selectedItem: itemUploadFile,
  } = useModal<DocRequestEntity>();

  if ( !data?.length ) return null;

  return (
    <>
      <TableEdit>
        <thead>
          <tr>
            <th>ID</th>
            <th style={{ minWidth: 190 }}>Nombre</th>
            <th>Descripción</th>
            <th className="text-center" style={{ width: 120 }}>Últ. Rev.</th>
            <th className="text-center" style={{ width: 120 }}>F. Límite</th>
            <th className="text-center" style={{ width: 110 }}>Estado</th>
            <th className="text-center" style={{ width: 120 }}>F. Expiración</th>
            <th style={{ width: 160 }} />
          </tr>
        </thead>

        <tbody>
          {data?.map( ( item ) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>
                <div className="text-truncate-2">{item.nombre}</div>
              </td>
              <td>
                <div className="text-truncate-2">
                  <div className="text-truncate-2">{item.descripcion}</div>
                </div>
              </td>
              <td className="text-center">
                <div className="text--black10">{item.fechaUltimaRevision ? moment( item.fechaUltimaRevision ).format( 'DD/MM/YY' ) : ''}</div>
              </td>
              <td className="text-center">
                <div className="text--black10">{item.fechaLimite ? moment( item.fechaLimite ).format( 'DD/MM/YY' ) : ''}</div>
              </td>
              <td className="d-flex justify-content-center">
                <DocStatusBadge status={item.estado as DocRequestStatus} />
              </td>
              <td className="text-center">
                <div className="text--black10">{item.fechaExpiracion ? moment( item.fechaExpiracion ).format( 'DD/MM/YY' ) : ''}</div>
              </td>
              <td className="text-center">
                <Button
                  className="px-1 py-0"
                  variant="link"
                  onClick={() => openCanvas( item )}
                >
                  <AiOutlineMenu />
                </Button>
                <Button
                  className="px-1 py-0"
                  variant="link"
                  disabled={!( !!item.nombreArchivo && !!item.urlArchivo )}
                  onClick={() => {
                    if ( !item.id || !item.urlArchivo || !item.nombreArchivo
                      || !item.tipoArchivo
                    ) return;
                    handleViewDocument(
                      item.id,
                      item.cuentaDeInversionID,
                      item.urlArchivo,
                      item.nombreArchivo,
                      item.tipoArchivo,
                      false,
                    );
                  }}
                >
                  <IoEyeOutline />
                </Button>
                <Button
                  className="px-1 py-0"
                  variant="link"
                  onClick={() => openUploadFileModal( item )}
                >
                  <ImAttachment className="text--md" />
                </Button>
                <Button
                  className="px-1 py-0"
                  variant="link"
                  disabled={!( !!item.nombreArchivo && !!item.urlArchivo )}
                  onClick={() => {
                    if ( !item.id || !item.urlArchivo || !item.nombreArchivo
                      || !item.tipoArchivo
                    ) return;
                    handleViewDocument(
                      item.id,
                      item.cuentaDeInversionID,
                      item.urlArchivo,
                      item.nombreArchivo,
                      item.tipoArchivo,
                      true,
                    );
                  }}
                >
                  <FiDownload />
                </Button>
              </td>
            </tr>
          ) )}
        </tbody>
      </TableEdit>

      {showCanvas && (
        <DocDetailOffcanvas
          onClose={closeCanvas}
          data={selectedItem}
          handleViewDocument={handleViewDocument}
        />
      )}
      {showUploadFileModal && (
      <UploadDocModal
        data={itemUploadFile}
        onClose={closeUploadFileModal}
        reloadData={reloadData}
      />
      )}
    </>
  );
}

export default DocsTableEdit;
